import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';


const AfficheClient = async (page) => {
    return await axios.get(`${BASE_URL}/api/societe/afficheClient/${page}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

const SuprimerClient = async (idClient) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteClient/${idClient}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


const EnvoyeEmail = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/envoyeEmailClient`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


const AuthClientRequest = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/authClientSociete`, data,{
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


export { AfficheClient, SuprimerClient, EnvoyeEmail, AuthClientRequest }